<template>

<app-page title="Hospitals" back="Dashboard" :is-loading="is.loading">

    <app-panel title="Hospitals" :is-loading="is.loading" :is-empty="is.empty">

        <app-table>
            <thead>
                <tr>
                    <th>Name</th>
                    <th width="100" align="center">Clinic Users</th>
                    <th width="100" align="center">Data Users</th>
                    <th width="60"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in collection" :key="item.id">
                    <td>{{ item.name }}</td>
                    <td align="center">{{ item.clinic }}</td>
                    <td align="center">{{ item.data }}</td>
                    <td><app-button text="View" route="Hospital" :id="item.id" /></td>
                </tr>   
            </tbody>
        </app-table>

    </app-panel>

    <app-actions>

        <app-button text="Add Hospital" route="Hospital" id="create" />

    </app-actions>

</app-page>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

    mixins: [mixCollection],

    data: function() {
    
        return {
            api: 'hospitals'
        }
    
    }

}

</script>

<style scoped>

</style>
